import Hud from 'app/ui/hud/Hud';
import ScreenContainer from '../../display/ui/ScreenContainer';

export default class HudPause extends Phaser.Group {
  constructor(game) {
    super(game);

    this.backing = this.game.make.graphics();
    this.backing.beginFill(0x8a308a);
    this.backing.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);
    this.backing.alpha = 0.75;
    // in theory should block everything behind this
    // theories arn't perfect ;)
    this.backing.inputEnabled = true;
    this.add(this.backing);

    // Overlay
    this.bgOverlay = new ScreenContainer(this.game, { background: 'background_alt_overlay' });
    this.add(this.bgOverlay);

    // add the hud
    this.hud = new Hud(this.game, Hud.PAUSE);
    this.game.add.existing(this.hud);
  }

  destroy() {
    this.bgOverlay.destroy();
    this.bgOverlay = null;
    this.hud.destroy();
    this.backing.destroy();
    this.hud = null;
    this.backing = null;
    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/hud/HudPause.js